import { NextRequest, NextResponse } from 'next/server';
import { db } from '@/lib/db';
import { verifyToken } from '@/lib/auth';

export async function GET(request: NextRequest) {
  try {
    // Get token from Authorization header
    const authHeader = request.headers.get('authorization');
    const token = authHeader?.replace('Bearer ', '');

    if (!token) {
      return NextResponse.json(
        { error: 'No token provided', isValid: false },
        { status: 401 }
      );
    }

    // Verify token
    const decoded = await verifyToken(token);
    if (!decoded) {
      return NextResponse.json(
        { error: 'Invalid token', isValid: false },
        { status: 401 }
      );
    }

    // Get user from database
    const user = await db.users.findByEmail(decoded.email);
    if (!user) {
      return NextResponse.json(
        { error: 'User not found', isValid: false },
        { status: 404 }
      );
    }

    // Check user status
    if (user.status === 'suspended') {
      return NextResponse.json(
        { 
          error: 'Account suspended', 
          isValid: false,
          status: 'suspended',
          message: 'Your account has been suspended by admin.'
        },
        { status: 403 }
      );
    }

    if (user.status === 'deleted') {
      return NextResponse.json(
        { 
          error: 'Account deleted', 
          isValid: false,
          status: 'deleted',
          message: 'Your account has been deleted.'
        },
        { status: 403 }
      );
    }

    // User is active
    return NextResponse.json({
      isValid: true,
      status: user.status,
      user: {
        id: user.id,
        email: user.email,
        fullName: user.fullName,
        role: user.role,
        status: user.status
      }
    });

  } catch (error) {
    console.error('Status check error:', error);
    return NextResponse.json(
      { error: 'Internal server error', isValid: false },
      { status: 500 }
    );
  }
}
